import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  handleKeydown(event) {
    // Submit on Enter (except for textareas, which support Ctrl/Cmd+Enter)
    if (event.key === 'Enter' && !event.shiftKey && event.target.tagName !== 'TEXTAREA') {
      event.preventDefault()
      this.element.requestSubmit()
    }

    // Submit on Ctrl+Enter or Cmd+Enter for textareas
    if (event.key === 'Enter' && (event.ctrlKey || event.metaKey) && event.target.tagName === 'TEXTAREA') {
      event.preventDefault()
      this.element.requestSubmit()
    }

    // Cancel on Escape
    if (event.key === 'Escape') {
      event.preventDefault()
      // Find and click the cancel link (either btn-link or btn-secondary)
      const cancelLink = this.element.querySelector('a.btn-link, a.btn-secondary')
      if (cancelLink) {
        cancelLink.click()
      }
    }
  }

  // Submit the form when the input loses focus. The server decides whether
  // to persist or destroy based on whether the title is blank — keeps the
  // delete-blank-draft policy in one place (the controller).
  handleBlur(event) {
    // Focus moved to another element inside the same form (e.g. the ✓ submit
    // button). Let the button's own click handler drive the submit instead of
    // double-firing here.
    if (event.relatedTarget && this.element.contains(event.relatedTarget)) {
      return
    }
    this.element.requestSubmit()
  }

  // Cancel button: clear the title and submit. The server treats a blank
  // title as a request to destroy the draft, so this reuses the same
  // server-side path as blur-to-empty rather than wiring a separate DELETE.
  cancel(event) {
    event.preventDefault()
    const input = this.element.querySelector('input[type="text"]')
    if (input) input.value = ''
    this.element.requestSubmit()
  }

  updateRangeDisplay(event) {
    // Find the display element next to the range
    const displayElement = event.target.parentElement.querySelector('[data-range-display-target="display"]')
    if (displayElement) {
      displayElement.textContent = event.target.value
    }
  }

  submitForm(event) {
    // Submit the form when range slider changes (on mouse release)
    this.element.requestSubmit()
  }
}